import { HeartPulse } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useI18n } from '../core/i18n'

export function Brand({ compact = false }: { compact?: boolean }) {
  const { tr } = useI18n()
  return (
    <Link className="brand" to="/" aria-label={tr.serviceName}>
      <span className="brand-mark"><HeartPulse size={19} strokeWidth={2.4} /></span>
      {!compact && <span className="brand-copy"><strong>{tr.serviceName}</strong><small>{tr.serviceSubtitle}</small></span>}
    </Link>
  )
}
